import { FC, useEffect, useState } from "react";
import { BarVisualizer, useSpeakingParticipants, useTracks } from "@livekit/components-react";
import { Participant, Track } from "livekit-client";

const ChatFormVoiceVisualizer: FC = () => {
  const tracks = useTracks();
  const speakingParticipants = useSpeakingParticipants();
  const [lastSpokenParticipant, setLastSpokenParticipant] = useState<Participant | null>(null);

  useEffect(() => {
    if (speakingParticipants.length > 0) {
      setLastSpokenParticipant(speakingParticipants[0]);
    }
  }, [speakingParticipants]);

  const audioTracks = tracks.filter((trackRef) => trackRef.publication.kind === Track.Kind.Audio);
  const lastSpokenTrackRef = lastSpokenParticipant
    ? (audioTracks.find((trackRef) => trackRef.participant.sid === lastSpokenParticipant.sid) ?? undefined)
    : undefined;

  return (
    <BarVisualizer
      barCount={5}
      trackRef={lastSpokenTrackRef}
    />
  );
};

export default ChatFormVoiceVisualizer;
